module.exports = __webpack_public_path__ + "static/media/mainlogo.68029509.png";